module.exports = __webpack_public_path__ + "static/media/beckyMock.f2e352f1.jpg";